import Sentry from 'plugins/sentry.TARGET';

// sets up printing data for page
// used on the page that is going to be printed, for instance Object.vue
const printSetup = {
  computed: {
    printingBool() {
      const { printing } = this.$store.state.objects.printData;
      return printing;
    },
  },
  mounted() {
    this.collapsiblesStateGetter();
  },
  methods: {
    collapsiblesStateGetter() {
      const { openCollapsibles, closeCollapsibles, ignoredCollapsibles } = this.$store.state.objects.printData;
      // check states of collpasibles to use them later for the actual print
      // closed elements should be opened , after print collpasibles should be closed again etc.
      this.$root.$on('bv::collapse::state', (collapseId, opened) => {
        if (opened === false) {
          if (!(openCollapsibles.includes(collapseId) || ignoredCollapsibles.includes(collapseId))) {
            this.$store.commit('SET_PRINT_COLLAPSIBLES', { action: 'add', value: collapseId });
          }
        } else if (opened === true) {
          const indexOfEl = openCollapsibles.indexOf(collapseId);
          if (indexOfEl !== -1) {
            this.$store.commit('SET_PRINT_COLLAPSIBLES', { action: 'rm', value: indexOfEl });
          }
        }
        if (!(closeCollapsibles.includes(collapseId) || ignoredCollapsibles.includes(collapseId))) {
          this.$store.commit('SET_PRINT_COLLAPSIBLES', { action: 'addToClose', value: collapseId });
        }
      });
    },
  },
};

// set up the actual print action in desired view/component
// For instance SocialShareButtons.vue
const printAction = {
  methods: {
    // scrolls to specific position of page
    scrollToElement(multiplicator) {
      const { innerHeight } = window;
      const retVal = new Promise((resolve) => {
        window.scrollBy({
          top: multiplicator * innerHeight,
          behavior: 'smooth'
        });
        setTimeout(() => resolve(true), 1000);
      });
      return retVal;
    },
    // called in printPage to make sure elements had enough time to be loaded
    printAction() {
      const retVal = new Promise((resolve) => {
        setTimeout(() => resolve(true), 2000);
      });
      return retVal;
    },
    async printPage() {
      try {
        const {
          openCollapsibles, closeCollapsibles, firstScrollMultiplicator, secondScrollMultiplicator, thirdScrollMultiplicator,
        } = this.$store.state.objects.printData;
        this.$store.commit('SET_PRINT_STATUS_AND_ERROR', { action: 'printing', bool: true });
        this.$store.commit('SET_PRINT_STATUS_AND_ERROR', { action: 'error', bool: false });

        const { printing } = this.$store.state.objects.printData;

        /* defined scroll to elements in state as this is currently
         the only page where we are using the print option
         to use this for other pages as well
         define scroll to Elements in component that has the print event and remove them from state */

        // scroll to elements to force them to load
        await this.scrollToElement(firstScrollMultiplicator);
        await this.scrollToElement(secondScrollMultiplicator);
        await this.scrollToElement(thirdScrollMultiplicator);
        // open defined elements
        if (printing) {
          openCollapsibles.forEach((collapsible) => {
            this.$root.$emit('bv::toggle::collapse', collapsible);
          });
        }
        await this.printAction();
        window.print();
        this.$store.commit('SET_PRINT_STATUS_AND_ERROR', { action: 'printing', bool: false });
        closeCollapsibles.forEach((collapsible) => {
          this.$root.$emit('bv::toggle::collapse', collapsible);
        });
        window.scrollTo(0, 0);
      } catch (err) {
        if (process.env.NODE_ENV === 'production') {
          Sentry.captureException(err);
        } else {
          // eslint-disable-next-line no-console
          console.error(err);
        }
        this.$store.commit('SET_PRINT_STATUS_AND_ERROR', { action: 'printing', bool: false });
        this.$store.commit('SET_PRINT_STATUS_AND_ERROR', { action: 'error', bool: true });
        window.scrollTo(0, 0);
      }
    },
  },
};
export { printSetup, printAction };
